import React, { useState } from "react";
import { Button, Icon, Dropdown } from "xsolla-uikit";
import { Link } from "react-router-dom";
import PAh2 from "../PAh2";
import styled from "styled-components";
import "./css/xcomadd2.css";


export function PAxcomOneCard ({
  inProgress,
  index = 0,
  handlePop = () => void (0),
  size = 'md',
  badgeText = false, //steam uses this solution,false
  title = "Title",
  description = "Short Description",
  descrLong,
  // descrLong = "Long Descript ion",
  // img = "https://assets.website-files.com/5d303aa1e8832120171290c0/5d36ec9631adeb60604a357d_17698.jpg",
  imageUrl,
  learnMoreUrl = '/',
  icon,
  intTime = "less than 3 minutes",
  intStep0 = "", intStep1 = "", intStep2 = "", intStep3 = "", intStep4 = "", intStep5 = "",
} ) {
  return (

  <div className="p_x_sol_item p_x_sol_item--x w-dyn-item">
<div className="p_x_sol_item_inner">


<div className="p_content-block p_content-block--x">
<div className="p_x_card_z" />
<a href="#" className="p_x_card_click w-inline-block" />
<div className="p_spacer_badge0">
<div className="p_spacer_badge0 w-condition-invisible">
<div className="p_spacer_badge w-condition-invisible" />
</div>
<div className="p_spacer_badge0 w-condition-invisible">
<div className="p_spacer_badge w-condition-invisible" />
</div>
</div>
<div className="p_img_badge0">
<div className="p_modal_badge p_modal_badge--card">
<div>

{badgeText}

</div>
</div>
</div>
<div className="p_head_pic00" style={{height: 110}}>
<div className="p_head_pic0 p_head_pic0--top p_head_pic0--top--x">


<div className="p_img_placeholder">
<div className="p_icon w-condition-invisible w-embed">
<svg xmlns="http://www.w3.org/2000/svg" width={80} height={80} viewBox="0 0 48 48">
<g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth={2}>
<path d="M29 29V8l-4-7h-2l-4 7v21zm-10-6h-3l-3 3v7h2l4-4zm10 0h3l3 3v7h-2l-4-4zm-9 13v2m0 2v2m8-6v2m0 2v2m-4-2v2m6-8v2m0 2v2m-12-6v2m0 2v2" />
<path strokeLinecap="round" d="M7.778 42.222a3.111 3.111 0 0 1 6.222 0M7 36a3.111 3.111 0 0 1 3.111 3.111" />
<path d="M24 36v2m0-6v2m-4-2v2m8-2v2m-6-9h4m-2-7v-2m0-2v-2m0-2V8M1 43v2l2 2h42l2-2v-2z" />
<path strokeLinecap="round" d="M44 43V17a2 2 0 0 0-2-2H32M4 43V17a2 2 0 0 1 2-2h10m24.222 27.222a3.111 3.111 0 0 0-6.222 0M41 36a3.111 3.111 0 0 0-3.111 3.111" />
</g>
</svg>
</div>
<div className="p_icon w-embed">
<svg xmlns="http://www.w3.org/2000/svg" width={80} height={80} viewBox="0 0 43 42">
<path fill="currentColor" fillRule="nonzero" d="M28.375 34.655a1 1 0 0 1 .374.416l1.751 3.628 1.751-3.628a1 1 0 0 1 .374-.416l3.477-2.155-3.477-2.155a1 1 0 0 1-.374-.416L30.5 26.301l-1.751 3.628a1 1 0 0 1-.374.416L24.898 32.5l3.477 2.155zM16 23.874A4.002 4.002 0 0 1 13 20a1 1 0 0 1 2 0 2 2 0 1 0 2-2 4 4 0 0 1-1-7.874V9a1 1 0 0 1 2 0v1.126c1.725.444 3 2.01 3 3.874a1 1 0 0 1-2 0 2 2 0 1 0-2 2 4 4 0 0 1 1 7.874V25a1 1 0 0 1-2 0v-1.126zm6.473 9.476a1 1 0 0 1 0-1.7l4.601-2.852 2.525-5.233a1 1 0 0 1 1.802 0l2.525 5.233 4.6 2.852a1 1 0 0 1 0 1.7l-4.6 2.852-2.525 5.233a1 1 0 0 1-1.802 0l-2.525-5.233-4.6-2.852zm8.015-15.491a1 1 0 0 1 0-1.718l3.304-1.971 1.814-3.618a1 1 0 0 1 1.788 0l1.814 3.618 3.304 1.971a1 1 0 0 1 0 1.718l-3.304 1.971-1.814 3.618a1 1 0 0 1-1.788 0l-1.814-3.618-3.304-1.971zm4.58.404a1 1 0 0 1 .381.41L36.5 20.77l1.05-2.096a1 1 0 0 1 .382-.41L40.048 17l-2.116-1.263a1 1 0 0 1-.381-.41L36.5 13.23l-1.05 2.096a1 1 0 0 1-.382.41L32.952 17l2.116 1.263zm-15.465 13.53a1 1 0 1 1 .327 1.974C11.107 35.227 2.637 29.692.5 21.063c-2.14-8.632 2.78-17.441 11.28-20.212 8.5-2.77 17.714 1.427 21.144 9.634a1 1 0 0 1-1.846.771C28.05 4.012 19.91.304 12.4 2.752 4.893 5.2.554 12.97 2.44 20.582c1.887 7.614 9.367 12.502 17.163 11.212zm6.247-8.767a1 1 0 0 1 1.682 1.082c-3.266 5.074-9.555 7.186-15.16 5.086-5.598-2.097-9.024-7.84-8.268-13.843.757-6.006 5.5-10.69 11.442-11.287 5.944-.598 11.502 3.053 13.403 8.795a1 1 0 0 1-1.898.629C25.443 8.63 20.753 5.55 15.746 6.054c-5.01.503-9.017 4.46-9.658 9.547-.64 5.089 2.26 9.95 6.986 11.72 4.72 1.77 10.018-.01 12.776-4.295z" />
</svg>
</div>
<div className="p_icon w-condition-invisible w-embed">
<svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48">
<g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth={2} transform="translate(1 1)">
<path strokeLinecap="round" d="M40 38l-5-5v-6h-6l-4-7v-2h12v-7h-2l-2 3h-8V9h6V5h-4V1m-9.935 0L17 13l-6 6v4h10v18h-2l-8-8v-6H7l-4-4m42 4h-4v4" />
<circle cx={23} cy={23} r={23} />
</g>
</svg>
</div>
<div className="p_spacer_image p_spacer_image--sm" />
</div>


<div
  style={{
    backgroundImage: `url(${imageUrl})`
  }}
  className="p_img_com p_img_com--x" />
<div className="p_bi0 w-condition-invisible">
<div className="p_bi_z" />
<div className="p_bi1">
<div className="w-embed">
<style dangerouslySetInnerHTML={{__html: "\n.p_bi_rich h1 {\nfont-family: 'Sharp Grotesk 15', sans-serif\n}\n.p_bi_rich p {\n  padding-top: 4px;\n}\n\n\n" }} />
</div>
<div className="p_bi_rich w-dyn-bind-empty w-richtext" />
</div>
</div>
<div className="p_img_grad" />
</div>
</div>
<div className="p_card_txt">
<div className="p_modal_c p_head">
<div className="p_head_b p_head_b--border--x">
<div className="t_h3 t_h3--x">{title}</div>
</div>
</div>
<div className="p_x_grow">
<div className="p_modal_c">
<div className="p_formgroup_sm8">
<div className="p_x_short">
<div className="p_x_descr p_x_descr--sm w-richtext">
<p>{description}</p>
</div>
</div>
</div>
<div className="p_formgroup_sm">
<div className="p_x_readmore">
<div className="l_flex">
<a href="/upsell-cards/boost-revenue-by-unlocking-south-korea-the-most-gaming-oriented-country" className="t_link w-inline-block">
<div className="x_sol_newtab w-embed">
<svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 19 19" fill="none">
                          <path d="M13.875 3.66667L10.9583 0.75H18.25V8.04167L15.3333 5.125L10.2194 10.2194L8.78056 8.78056L13.875 3.66667ZM9.5 0.75V3.66667H3.66667V15.3333H15.3333V9.5H18.25V15.3333C18.25 15.8648 18.1204 16.3574 17.8611 16.8111C17.6019 17.2519 17.2454 17.6019 16.7917 17.8611C16.3509 18.1204 15.8648 18.25 15.3333 18.25H3.66667C3.13519 18.25 2.64259 18.1204 2.18889 17.8611C1.74815 17.6019 1.39815 17.2519 1.13889 16.8111C0.87963 16.3574 0.75 15.8648 0.75 15.3333V3.66667C0.75 3.13518 0.87963 2.64907 1.13889 2.20833C1.39815 1.75463 1.74815 1.39815 2.18889 1.13889C2.64259 0.879629 3.13519 0.75 3.66667 0.75H9.5Z" fill="#3171EF" />
                        </svg>
</div>
<div className="t_blue">Learn more</div>
</a>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="p_formfooter p_formfooter--dash">
<div className="p_modal_c">
<div className="p_formgroup_sm">
<div className="x_flex x_flex--space x_flex--4center">
<div className="p_x_cta">
<div className="p_x_start">
<a data-a="trigger" href="#filter" className="p_button p_button--x p_button--x--0 w-inline-block">
<div className="w-condition-invisible w-dyn-bind-empty" />
<div>Integrate now</div>
</a>
</div>
</div>
</div>
</div>
</div>
<div className="p_modal_c">
<div className="p_formgroup_md">
<div className="p_x_int_time">

  {intTime && (<div>
    Integration time: <strong>{intTime}</strong>
  </div>)}

</div>
</div>
</div>
<div className="p_formgroup_sm" />
</div>
</div>
<div className="p_formfooter_info">
<div className="p_modal_c">
<div>You see this because you could earn more by selling your game in South Korea</div>
</div>
</div>
</div>
<div className="p_x_sol_lp">
<div className="l_block">
<div className="l_content_center">
<div className="l_width_1160">
<div className="l_paddings_m">
<div className="l_paddings_m">
<div className="l_text_with_label">
<div className="t_corner_right-top t_corner_right-top--white" />
<div className="t_label0">
<div className="t_label_w">
<div data-pa="back" className="t_label t_label--ghost">
<div>Solutions</div>
</div>
</div>
<div className="t_label_w t_label_w--2">
<div>&gt;</div>
</div>
<div className="t_label_w">
<div className="t_label-2">
<div className="t_label_txt-2 t_label_txt--dark">Payments Solutions</div>
</div>
</div>
</div>
</div>
<div className="x_home_hero_left">
<div className="l_line">
<h1 className="t_hero_h1">Boost revenue by unlocking South Korea</h1>
</div>
<div className="l_line">
<div className="t_hero_h2 w-richtext">
<p>New digital wallets like Toss, Payco and KakaoPay conquered the e-commerce market and now on their way to gaming vertical. Be among first companies to adopt advanced technologies and win Korean market.</p>
</div>
</div>
</div>
<div>
<div className="l_line">
<div className="x_solution_topcta">
<div className="x_main_cta">
<a href="#" className="x_button-accent x_button-accent--integrate w-inline-block">
<div className="text-block-5">Integrate now</div>
</a>
</div>
<a href="#" className="x_button-accent x_button-accent--sales w-inline-block">
<div className="text-block-5">Contact sales today</div>
</a>
</div>
</div>
<div className="l_line">
<div className="p_x_int_time p_x_int_time--lp">
<div>Integration time: <strong>less than 3 minutes</strong>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div style={{backgroundImage: 'url("https://assets.website-files.com/5d303aa1e8832120171290c0/5d36ec9631adeb60604a357d_17698.jpg")'}} className="x_home_top_pic x_home_top_pic--solutions-payments">
{/* <div style={{backgroundImage: 'url("https://assets.website-files.com/5d303aa1e8832120171290c0/5d36ec9631adeb60604a357d_17698.jpg")'}} className="x_home_top_pic x_home_top_pic--solutions-payments"> */}
<div className="x_home_top_pic--tint" />
</div>
</div>
<div className="l_block_bg" />
</div>
<div className="l_block">
<div className="l_content">
<div className="l_content_center">
<div className="l_width_1160">
<div className="l_paddings_l">
<div>
<div className="l_line">
<div>
<div className="l_line">
<h1 className="t_h2-2 t_h--black">
<span className="t_magenta">Monetize</span> in more markets<br />
</h1>
</div>
<div className="l_line">
<div className="l_paddings_s">
<div className="x_solutions_sublead x_solutions_sublead--width">
<strong>Payments </strong>lets you offer 700+ localized, preferred payment methods at a global scale, with a single agreement and integration, so you can easily expand your addressable market.<br />
</div>
</div>
</div>
</div>
<div className="l_paddings_m_bot">
<div className="x_solutions-grid x_solutions-grid--3">
<div className="x_slution_desc0">
<div className="l_line">
<div className="x_home_products_icon">
<div className="x_home_products_icon">
<div className="t_magenta w-embed">
<svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48">
<path fill="currentColor" fillRule="nonzero" d="M45 48h-2V35h2v13zM3 36H0V18h3V8h2v10h38V2H5v2.118h25.79v2H3V0h42v18h3v18H5v10h40v2H3V36zM37 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm6 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-24 6h23v2H16v-2zm0 28h23v2H16v-2zM2 20v14h44V20H2zm9-4a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 30a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm6-16h25v2H17v-2zm-7 6a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-1a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
</svg>
</div>
</div>
</div>
</div>
<div className="l_line">
<div className="x_home_products_icon">
<h2 className="t_solutions_h3-2">Global reach</h2>
</div>
</div>
<div className="l_line l_hero_line--last">
<div className="x_home_products_desc">
<div>
<strong>Make your game, products, and goods available in 200+ geographies</strong> and 20+ languages with instant, compliant access to 700+ payments methods and 130+ currencies.</div>
</div>
</div>
</div>
<div className="x_slution_desc0">
<div className="l_line">
<div>
<div className="x_home_products_icon">
<div className="t_magenta w-embed">
<svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48">
<path fill="currentColor" fillRule="nonzero" d="M45 48h-2V35h2v13zM3 36H0V18h3V8h2v10h38V2H5v2.118h25.79v2H3V0h42v18h3v18H5v10h40v2H3V36zM37 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm6 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-24 6h23v2H16v-2zm0 28h23v2H16v-2zM2 20v14h44V20H2zm9-4a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 30a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm6-16h25v2H17v-2zm-7 6a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-1a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
</svg>
</div>
</div>
</div>
</div>
<div className="l_line">
<div className="x_home_products_icon">
<h2 className="t_solutions_h3-2">Local approach</h2>
</div>
</div>
<div className="l_line l_hero_line--last">
<div className="x_home_products_desc">
<div>
<strong>Account for local spending behaviors </strong>by supporting methods from credit and debit to direct carrier billing, digital wallets, and cryptocurrencies.</div>
</div>
</div>
</div>
<div className="x_slution_desc0">
<div className="l_line">
<div className="x_home_products_icon">
<div className="x_home_products_icon">
<div className="t_magenta w-embed">
<svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48">
<path fill="currentColor" fillRule="nonzero" d="M45 48h-2V35h2v13zM3 36H0V18h3V8h2v10h38V2H5v2.118h25.79v2H3V0h42v18h3v18H5v10h40v2H3V36zM37 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm6 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-24 6h23v2H16v-2zm0 28h23v2H16v-2zM2 20v14h44V20H2zm9-4a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 30a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm6-16h25v2H17v-2zm-7 6a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-1a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
</svg>
</div>
</div>
</div>
</div>
<div className="l_line">
<div className="x_home_products_icon">
<h2 className="t_solutions_h3-2">More revenue</h2>
</div>
</div>
<div className="l_line l_hero_line--last">
<div className="x_home_products_desc">
<div>
<strong>Turn more gamers into paying customers</strong> with direct carrier billing on mobile and an adaptive form that requests only information that’s necessary for purchase.</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="l_line">
<div className="p_x_sol-grid">
<div />
<div className="pa_x_grid_right">
<div className="l_paddings_m-2">
<div className="pa_x_solut_cols">
<div className="l_line">
<div className="l_line l_hero_line--last">
<div className="l_flex-2">
<div className="t_label-3 t_label--transparent">
<div className="t_label_txt-3 t_label_txt--black">Products used</div>
</div>
<div className="t_label_line-2 t_label_line--black" />
</div>
</div>
</div>
<div>
<div>
<div className="l_line">
<div className="pa_x_productssmall">
<div className="pa_x_product1">
<div>
<div className="x_home_products_icon">
<img src="https://assets.website-files.com/5d2d1e42b1d78992ec4bcf44/5e2ff8794a557e4c9aa5b8c0_xsolla_paystation_magenta.svg" width={44} height={44} />
</div>
</div>
<div className="l_line l_line--sm">
<div className="pa_x_h4">
<div>Pay Station</div>
</div>
</div>
<div className="l_line l_hero_line--last">
<div className="pa_x_product_desc">
<div>Accept 700+ payment types, in 200+ geographies.<span className="x_home_blue-link" />
</div>
</div>
</div>
</div>
<div className="pa_x_product1">
<div>
<div className="x_home_products_icon">
<img src="https://assets.website-files.com/5d3220acbdb594eab7c06a9a/5d3220acbdb594e671c06cdd_xsolla_site_builder_magenta.svg" width={44} height={44} />
</div>
</div>
<div className="l_line l_line--sm">
<div className="pa_x_h4">
<div>Site Builder</div>
</div>
</div>
<div className="l_line l_hero_line--last">
<div className="pa_x_product_desc">
<div>Get the video game industry’s #1 fraud protection.<span className="x_home_blue-link" />
</div>
</div>
</div>
</div>
<div className="pa_x_product1">
<div>
<div className="x_home_products_icon">
<img src="https://assets.website-files.com/5d3220acbdb594eab7c06a9a/5d3220acbdb5949fcbc06ce3_xsolla_store_magenta.svg" width={44} height={44} />
</div>
</div>
<div className="l_line l_line--sm">
<div className="pa_x_h4">
<div>Store</div>
</div>
</div>
<div className="l_line l_hero_line--last">
<div className="pa_x_product_desc">
<div>Easily sell in-game goods, currency, subscriptions.<span className="x_home_blue-link" />
</div>
</div>
</div>
</div>
<div className="pa_x_product1">
<div>
<div className="x_home_products_icon">
<img src="https://assets.website-files.com/5d3220acbdb594eab7c06a9a/5d3220acbdb5943178c06cd4_xsolla_partner_network_magenta.svg" width={44} height={44} />
</div>
</div>
<div className="l_line l_line--sm">
<div className="pa_x_h4">
<div>Partner Network</div>
</div>
</div>
<div className="l_line l_hero_line--last">
<div className="pa_x_product_desc">
<div>Manage complex organic growth programs.<span className="x_home_blue-link" />
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="l_line hidden">
<div>
<div className="pa_x_productssmall">
<div className="pa_x_table_tr">
<div className="pa_x_h4 pa_x_h4--2">
<div className="pa_x_bullet" />
<div>Add Mailchimp™ export</div>
</div>
</div>
<div className="pa_x_table_tr">
<div className="pa_x_h4 pa_x_h4--2">
<div className="pa_x_bullet" />
<div>Create a forum</div>
</div>
</div>
<div className="pa_x_table_tr">
<div className="pa_x_h4 pa_x_h4--2">
<div className="pa_x_bullet" />
<div>Create a remarketuing campaign</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="l_line">
<div className="l_line">
<div className="l_flex-2">
<div className="t_label-3 t_label--transparent">
<div className="t_label_txt-3 t_label_txt--black">Documentation</div>
</div>
<div className="t_label_line-2 t_label_line--black" />
</div>
</div>
<div className="l_line">
<div>
<div className="l_line">
<div>
<div className="pa_x_productssmall">
<div className="pa_x_table_tr">
<div>
<a href="#" className="x_home_blue-link">Recipe</a>
</div>
</div>
<div className="pa_x_table_tr">
<div>
<a href="https://developers.xsolla.com/doc/site-builder/#guides_sitebuilder_create_site" target="_blank" className="x_home_blue-link">Creating a Site</a>
</div>
</div>
<div className="pa_x_table_tr">
<div>
<a href="#" className="x_home_blue-link">User Flow</a>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="l_block_bg" />
</div>
<div className="l_block">
<div className="l_content" />
<div className="l_block_bg" />
</div>
</div>
</div>


  )
}



export function PAxcomOneCard1({
  inProgress,
  index = 0,
  handlePop = () => void (0),
  size = 'md',
  badgeText = false, //steam uses this solution,false
  title = "Title",
  description = "Short Description",
  descrLong,
  // descrLong = "Long Descript ion",
  // img = "https://assets.website-files.com/5d303aa1e8832120171290c0/5d36ec9631adeb60604a357d_17698.jpg",
  imageUrl,
  learnMoreUrl = '/',
  icon,
  intTime = "less than 3 minutes",
  intStep0 = "", intStep1 = "", intStep2 = "", intStep3 = "", intStep4 = "", intStep5 = "",

}) {
  const [state, setState] = useState({
    assign: false
  });
  const [popState, setPopState] = useState(false);



  return (
  <CSScard0 className="p_x_sol_item_inner" style={{
    minHeight: 380,
    // width: 310,
  }}>


    <div className="p_content-block p_content-block--sol">
      <div className="p_x_card_z" />
      <a href="#pa-3-int1" className="p_x_card_click w-inline-block" />



      {!!badgeText && (<div className="p_img_badge0">
        <div className="p_modal_badge p_modal_badge--sm">
          <div>{badgeText}</div>
        </div>
      </div>)}

      {size === 'sm' && <div style={{ height: 40 }} />}

      {size === 'md' && <div className="p_head_pic0 p_head_pic0--top p_head_pic0--top--sm" style={{
        borderRadius: '8px 8px 0px 0px',
      }}>

        <div className="p_img_placeholder">

          {!imageUrl && size === 'md' && (<div className="">
            <div className="p_icon w-condition-invisible w-embed">


              {!!icon && icon}


            </div>
            <div className="p_icon w-embed">
              <svg width={80} height={80} viewBox="0 0 43 42">
                <path fill="currentColor" fillRule="nonzero" d="M28.375 34.655a1 1 0 0 1 .374.416l1.751 3.628 1.751-3.628a1 1 0 0 1 .374-.416l3.477-2.155-3.477-2.155a1 1 0 0 1-.374-.416L30.5 26.301l-1.751 3.628a1 1 0 0 1-.374.416L24.898 32.5l3.477 2.155zM16 23.874A4.002 4.002 0 0 1 13 20a1 1 0 0 1 2 0 2 2 0 1 0 2-2 4 4 0 0 1-1-7.874V9a1 1 0 0 1 2 0v1.126c1.725.444 3 2.01 3 3.874a1 1 0 0 1-2 0 2 2 0 1 0-2 2 4 4 0 0 1 1 7.874V25a1 1 0 0 1-2 0v-1.126zm6.473 9.476a1 1 0 0 1 0-1.7l4.601-2.852 2.525-5.233a1 1 0 0 1 1.802 0l2.525 5.233 4.6 2.852a1 1 0 0 1 0 1.7l-4.6 2.852-2.525 5.233a1 1 0 0 1-1.802 0l-2.525-5.233-4.6-2.852zm8.015-15.491a1 1 0 0 1 0-1.718l3.304-1.971 1.814-3.618a1 1 0 0 1 1.788 0l1.814 3.618 3.304 1.971a1 1 0 0 1 0 1.718l-3.304 1.971-1.814 3.618a1 1 0 0 1-1.788 0l-1.814-3.618-3.304-1.971zm4.58.404a1 1 0 0 1 .381.41L36.5 20.77l1.05-2.096a1 1 0 0 1 .382-.41L40.048 17l-2.116-1.263a1 1 0 0 1-.381-.41L36.5 13.23l-1.05 2.096a1 1 0 0 1-.382.41L32.952 17l2.116 1.263zm-15.465 13.53a1 1 0 1 1 .327 1.974C11.107 35.227 2.637 29.692.5 21.063c-2.14-8.632 2.78-17.441 11.28-20.212 8.5-2.77 17.714 1.427 21.144 9.634a1 1 0 0 1-1.846.771C28.05 4.012 19.91.304 12.4 2.752 4.893 5.2.554 12.97 2.44 20.582c1.887 7.614 9.367 12.502 17.163 11.212zm6.247-8.767a1 1 0 0 1 1.682 1.082c-3.266 5.074-9.555 7.186-15.16 5.086-5.598-2.097-9.024-7.84-8.268-13.843.757-6.006 5.5-10.69 11.442-11.287 5.944-.598 11.502 3.053 13.403 8.795a1 1 0 0 1-1.898.629C25.443 8.63 20.753 5.55 15.746 6.054c-5.01.503-9.017 4.46-9.658 9.547-.64 5.089 2.26 9.95 6.986 11.72 4.72 1.77 10.018-.01 12.776-4.295z" />
              </svg>
            </div>
          </div>)}



          <div className="p_spacer_image p_spacer_image--sm" />
        </div>

        {imageUrl && size === 'md' && (<div style={{
          backgroundImage: `url(${imageUrl})`
        }} className="p_img_com" />)}
      </div>}

      <div className="p_head p_head--sm">
        <div className="p_head_b p_head_b--border-0">
          <PAh2 tag="h4" indentation="sm" title={title} wrap="normal" />
        </div>
      </div>

      <div className="p_x_grow">
        <div className="p_modal_c">
          <div className="p_formgroup_sm8">
            <div className="p_x_short">
              <div className="p_x_descr p_x_descr--sm w-richtext">
                <p>
                  {description}
                </p>
              </div>
            </div>

            {descrLong && (<div className="p_x_learnmore">
              <div className="p_int_time0 p_int_time0--l">
                <a href={learnMoreUrl}>Learn more</a>
              </div>
            </div>)}
          </div>
          <div className="p_formgroup_sm">
            <div className="p_x_int_time">
              <div>
                {intTime && (<div>
                  Integration time: <strong>{intTime}</strong>
                </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p_formfooter p_formfooter--dash">
        <div className="p_formgroup_sm">
          <div className="p_modal_c">
            <div className="p_formgroup_xs">
              <div className="p_comp_int-ctas">
                <div className="x_flex x_flex--space x_flex--4center">
                  <div
                    // className="p_x_button-negative"
                    style={{
                      width: '100%',
                      margin: '0 0 16px 0'
                    }}>
                    <div className="p_x_start" style={{width: '100%'}}>



                      <div className="l_flex" style={{justifyContent: 'space-between', width: '100%'}}>

                        {!inProgress && <Link to={learnMoreUrl} className="p_button p_button--sm">
                          <div>Use now</div>
                        </Link>}

                        {inProgress && <Link to={learnMoreUrl}
                          className="p_button p_button--sm"
                          style={{
                            backgroundColor: '#ffc500',
                            boxShadow: '0 3px 6px -4px #ffc500',
                          }}>
                          <div>Finish setup</div>
                        </Link>}


                        <Dropdown
                          align="right-half-back"
                          position="top"
                          size="sm"
                          autosize={"md"}
                          options={[
                              {
                                label: "I'm not interested",
                                value: 0,
                                // description: `The file must contain these fields in the following order: platform, currency, price. Use a line break as the separator.`
                              },
                              {
                                label: "Contact account manager",
                                value: 1,
                                // description: `The file must contain these fields in the following order: platform, currency, price. Use a line break as the separator.`
                              },
                              {
                                label: "Assign to co-worker",
                                value: 2,
                                // description: `The file must contain these fields in the following order: platform, currency, price. Use a line break as the separator.`
                              },
                            ]}
                          >
                          <div style={{color: '#c5d0db'}} appearance="flatten">
                            <Icon name="more" />
                          </div>
                        </Dropdown>

                        {/* &nbsp;&nbsp;&nbsp;&nbsp; */}


                        {/* <Button appearance="flatten" size="sm" onClick={() => {
                          setPopState(true);
                          handlePop(index);
                        }}>
                          <div>Learn more</div>
                        </Button> */}

                      </div>

                    </div>
                  </div>

                  {/* <div className="p_x_right p_x_right--moved">

                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

      {/* <CSScardBecause>You see this because you could earn more by selling your game in South Korea</CSScardBecause> */}
  </CSScard0>);
}




const CSScardBecause = styled.div`
  padding-top: 0.8em;
  color: rgba(255, 255, 255, 0.59);
  font-size: 13px;
  line-height: 1.2em;
`

const CSScard0 = styled.div`
  &:hover {
    z-index: 10;
  }
`